// Course Model
import { Model } from '@vuex-orm/core';

export default class Trophy extends Model {
    // This is the name used as module name of the Vuex Store.
    static entity = 'trophies';

    // List of all fields (schema) of the post model. `this.attr` is used
    // for the generic field type. The argument is the default value.
    static fields() {
        return {
            id: this.attr(null),
            title: this.attr(''),
            description: this.attr(''),
            activatable: this.attr(false),
            icon: this.attr('fa fa-star'),
            background: this.attr('#64C7CC'),
            border: this.attr('#4f9093'),
            color: this.attr('#455A64'),
            category: this.attr('custom'),
            xp: this.attr(''),
            uploads: this.attr([]),
            levels: this.attr([]),
            threshold: this.attr('1'),
            rank: this.attr(null),
            progress: this.attr(false),
            is_custom: this.attr(false),
            users: this.attr([]),
            error: this.attr(false),
        };
    }

    static apiConfig = {
        actions: {
            fetchCustom() {
                return new Promise((resolve) => {
                    const params = new URLSearchParams();

                    params.append('type', 'custom');

                    this.get('/api/v3/achievements', {
                        params,
                        dataTransformer: response => response.data.data,
                    }).then((response) => {
                        resolve(response);
                    });
                });
            },

            fetchById(id, relations = false) {
                return new Promise((resolve, reject) => {
                    const params = new URLSearchParams();

                    if (relations) {
                        params.append('with', relations);
                    }

                    this.get(`/api/v3/achievements/${id}`, {
                        params,
                        dataTransformer: response => response.data.data,
                    }).then((response) => {
                        resolve(response.response.data.data);
                    }).catch((error) => {
                        reject(error.response.data);
                    });
                });
            },
        },
    }
}

window.Trophy = Trophy;
